/* eslint-disable no-use-before-define */
import { LANG } from '../constants';
import I18NUtils from '../i18n/utils';
import ger from '../i18n/ger';
import eng from '../i18n/eng';
import withLocalStorage from './withLocalStorage';

function getLanguageFromNavigator() {
    const languages = navigator.languages;
    if (!languages) {
        return null;
    }
    for (let k = 0; k < languages.length; ++k) {
        if (languages[k].startsWith('en')) {
            return 'eng';
        } else if (languages[k].startsWith('de')) {
            return 'ger';
        }
    }
    return null;
}

const { getUserLanguage } = withLocalStorage();

const TranslationUtil = {
    getCurrentLanguage: function (lng) {
        if (lng) {
            return transformToKnownIso2B(lng);
        }

        const savedLanguage = getUserLanguage();
        if (savedLanguage) {
            return transformToKnownIso2B(savedLanguage);
        }

        const navigatorLanguage = getLanguageFromNavigator();
        if (navigatorLanguage) {
            return navigatorLanguage;
        }

        return transformToKnownIso2B(LANG);
    },
    getTranslationsForContext: function (context, currentLanguage) {
        const languages = {
            eng: eng,
            ger: ger,
        };

        const strings = languages[currentLanguage][context];
        strings._currentLanguage = currentLanguage;
        strings._utils = new I18NUtils(currentLanguage);

        return strings;
    },
};

function transformToKnownIso2B(lang) {
    switch (lang) {
        case 'de':
        case 'ger':
            return 'ger';
        case 'en':
        case 'eng':
            return 'eng';
        default:
            return LANG;
    }
}

export default TranslationUtil;
